export default __webpack_public_path__ + "static/media/Fubmatten.13be48be.jpg";